module.exports = __webpack_public_path__ + "4be984a3b7c813f2937097bdd83801f1.svg";